import digitalData from 'digital-data';
import { setAnalytics } from '../../../thd-analytics-utils';

export function myAccountHomeDepotCreditCard() {
  window.LIFE_CYCLE_EVENT_BUS.on('myaccount.home-depot-credit-card.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: ' account>home depot credit card ',
        pageType: 'maml: credit card',
      },
      category: {
        primaryCategory: 'account',
        subCategory1: 'account>home depot credit card',
        subCategory2: 'account>home depot credit card',
      },
    };

    setAnalytics(digitalData);
  });
}